import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {StandardName} from "../../../../store/state/order.state";
import {FormGroup} from "@angular/forms";
import {CompanyGeneralInfoFormService} from "../form-service/company-general-info.form.service";
import {distinctUntilChanged} from "rxjs/operators";
import {Observable, Subscription} from "rxjs";

@Component({
    selector: 'shifts-number',
    templateUrl: './shifts-number.template.html',
    styleUrls: ['../company-general-info.style.scss', './shifts-number.style.scss'],
    standalone: false
})
export class ShiftsNumberComponent implements OnInit, OnDestroy {

	@Input() standard: StandardName;
	@Input() form: FormGroup;
	@Input() formService: CompanyGeneralInfoFormService;

	readonly selectableShiftsMore: number[] = [4, 5, 6, 7, 8, 9, 10];

	private subscription: Subscription;

	constructor(private changeDet: ChangeDetectorRef) {
	}

	ngOnInit(): void {
		this.subscription = this.formService.onStatusChange('shiftsNumber', this.getFormKey()).pipe(
			distinctUntilChanged()
		).subscribe(value => {
			this.changeDet.detectChanges();
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	getFormKey(): string {
		return this.standard;
	}

	shouldDisableRadio(controlName: string): boolean {
		const control = this.formService.getFormControl(this.standard, controlName);
		return control != null ? control.disabled : false;
	}

	fullControlName(controlPrefix: string) {
		return controlPrefix + this.standard;
	}

	isInvalid(controlPrefix: string) {
		return this.formService.isInvalid(this.standard, controlPrefix);
	}

	getValidationErrors(controlPrefix: string): Observable<string> {
		return this.formService.getErrorsString(this.getFormKey(), controlPrefix);
	}

	isFormControlIncludedInForm(controlPrefix: string) {
		return this.formService.getFormControl(this.standard, controlPrefix) != null;
	}
}
